import { render, staticRenderFns } from "./OrderDropoff.vue?vue&type=template&id=1f49f4bb&"
import script from "./OrderDropoff.vue?vue&type=script&lang=js&"
export * from "./OrderDropoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports